import { httpsCallable } from "firebase/functions";
import { functions } from ".";
import { isStringNotEmpty } from "../utils/objectUtils";

export const sendImpactConversion = async (subAffiliateId, leadId, clickId = null) => {
    if ((isStringNotEmpty(subAffiliateId) || isStringNotEmpty(clickId)) && isStringNotEmpty(leadId)) {
        const func = httpsCallable(functions, "sendimpactconversion", { timeout: 6000000 });

        const res = await func({ subAffiliateId: subAffiliateId, leadId: leadId, clickId: clickId });

        console.log(res.data);
        return res.data;
    }

    return null;
};

export const sendImpactPageLoad = async (subAffiliateId, siteVisitId, pageUrl, referrerUrl, userAgent, ipAddress) => {
    if (isStringNotEmpty(subAffiliateId) && isStringNotEmpty(siteVisitId)) {
        const func = httpsCallable(functions, "sendimpactpageload", { timeout: 6000000 });

        const res = await func({
            subAffiliateId: subAffiliateId,
            siteVisitId: siteVisitId,
            pageUrl: pageUrl,
            referrerUrl: referrerUrl,
            userAgent: userAgent,
            ipAddress: ipAddress
        });

        console.log(res.data);
        return res.data;
    }

    return null;
};